import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  checkCustomSurveyTemplateUsage,
  TemplateUsageInfo,
} from '../../api/customSurveyTemplates';

export const useCheckCustomSurveyTemplateUsageQuery = (
  templateId: number | null,
  options?: Omit<
    UseQueryOptions<TemplateUsageInfo, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery<TemplateUsageInfo, Error>({
    queryKey: ['customSurveyTemplateUsage', templateId],
    queryFn: () => checkCustomSurveyTemplateUsage(templateId!),
    enabled: templateId !== null,
    ...options,
  });
};
